@if (baseRules?.hasOutstanding && !isReviewPage) {
  <h2 class="axis-h4">Colorado</h2>
  @if (reactiveForm) {
    <form [formGroup]="reactiveForm">
      <!-- UM Radio Group level one -->
      @if (controls?.length >= 1) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[0].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[0].formControlName)?.touched &&
              reactiveForm.get(controls[0].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[0].formControlName }}">
            @for (control of controls[0].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[0].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[0].formControlName)?.touched) {
            @if (reactiveForm.get(controls[0].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UMBI Radio Group level two -->
      @if (controls?.length >= 2) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[1].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[1].formControlName)?.touched &&
              reactiveForm.get(controls[1].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[1].formControlName }}">
            @for (control of controls[1].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                class="{{ control.class }}"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[1].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[1].formControlName)?.touched) {
            @if (reactiveForm.get(controls[1].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UMBI Dropdowns -->
      <div class="axis-grid _ml-large">
        @for (control of controls | slice: 3; track $index) {
          @if (control.formControlName.startsWith("UMBI_") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>

      <div class="axis-grid">
        @if ((baseRules?.["UMBI_SplitMinLimits_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[5].label }}</label>
              <div id="umbi_splitminlimits_25k_50k-pdffield-colorado">
                {{ controls[5].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["UMBI_CombinedSingleMinLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[6].label }}</label>
              <div id="umbi_combinedsingleminlimit_50k-pdffield-colorado">
                {{ controls[6].data[0].name }}
              </div>
            </div>
          </div>
        }
        @if ((baseRules?.["LiabilityLimit_DropDown"] || "").includes("readonly")) {
          <div class="axis-col-sm-6 axis-col-lg-6">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ controls[9].label }}</label>
              <div
                id="liabilitylimit_Limit_equal_to_the_limit_of_my_Bodily_Injury_Liability_Coverage-pdffield-colorado"
              >
                {{ controls[9].data[0].name }}
              </div>
            </div>
          </div>
        }
      </div>

      @if (
        (baseRules?.["UMPDReject_LevelTwo_Radio"] || "").includes("show") ||
        (baseRules?.["UMPDCombinedSingleLimit_LevelTwo_Radio"] || "").includes("show")
      ) {
        <h3 class="axis-h5">
          Select Colorado Uninsured Property Damage (UMPD) Coverage
          <span
            aria-hidden="true"
            class="axis-required-indicator"
            >*</span
          >
        </h3>
      }
      <!-- UMPD Radio group level one -->
      @if (controls?.length >= 3) {
        <div
          class="axis-form-group _mt-medium"
          [ngClass]="{
            'has-axis-required': reactiveForm.get(controls[2].formControlName)?.value === null,
            'has-axis-error':
              reactiveForm.get(controls[2].formControlName)?.touched &&
              reactiveForm.get(controls[2].formControlName)?.invalid,
          }"
        >
          <axis-radio-button-wrapper formControlName="{{ controls[2].formControlName }}">
            @for (control of controls[2].option; track $index) {
              <axis-radio
                [hidden]="getRadioButtons(control)"
                heading="{{ control.label }}"
                value="{{ control.select }}"
                name="{{ controls[2].formControlName }}"
              ></axis-radio>
            }
          </axis-radio-button-wrapper>
          @if (reactiveForm.get(controls[2].formControlName)?.touched) {
            @if (reactiveForm.get(controls[2].formControlName)?.invalid) {
              <span
                class="axis-error-block"
                role="alert"
                >Please select an option.</span
              >
            }
          }
        </div>
      }

      <!-- UMPD Dropdowns -->
      <div class="axis-grid">
        @for (control of controls | slice: 3; track $index) {
          @if (control.formControlName.startsWith("UMPD") && baseRules[control.baseRuleKey]?.includes("show")) {
            <div class="axis-col-sm-6 axis-col-md-6">
              <div
                class="axis-form-group"
                [ngClass]="{
                  'has-axis-required':
                    reactiveForm.get(control.formControlName)?.value === null ||
                    reactiveForm.get(control.formControlName)?.value === '',
                  'has-axis-error':
                    reactiveForm.get(control.formControlName)?.touched &&
                    reactiveForm.get(control.formControlName)?.invalid,
                }"
              >
                <label
                  class="axis-control-label"
                  for="{{ control.formControlName }}"
                >
                  {{ control.label }}
                  <span
                    aria-hidden="true"
                    class="axis-required-indicator"
                    >*</span
                  >
                </label>
                <axis-dropdown
                  [dataProvider]="control.data"
                  id="{{ control.formControlName }}"
                  formControlName="{{ control.formControlName }}"
                ></axis-dropdown>
                @if (reactiveForm.get(control.formControlName)?.touched) {
                  @if (reactiveForm.get(control.formControlName)?.invalid) {
                    <span
                      class="axis-error-block"
                      role="alert"
                      >Please select the {{ control.label }}.</span
                    >
                  }
                }
              </div>
            </div>
          }
        }
      </div>
      @if ((baseRules?.["UMPDReject_LevelTwo_Radio"] || "").includes("Yes")) {
        <div class="axis-grid">
          <div class="axis-col-sm-6 axis-col-md-4">
            <div class="axis-form-group">
              <label class="axis-control-label">{{ textValues?.Reject_Text_UMPD }}</label>
              <div id="reject_levelthree_radio-pdffield-colorado">{{ baseRules?.UMPDReject_LevelTwo_Radio }}</div>
            </div>
          </div>
        </div>
      }
    </form>
  }
}

<!-- Review Section -->
@if (baseRules && !baseRules?.hasOutstanding && isReviewPage) {
  <h2 class="axis-h4">Colorado</h2>

  <!-- Reject texts -->
  @if (baseRules?.Reject_LevelOne_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
    </div>
  }

  @if (baseRules?.Reject_LevelOne_UIM_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text }}
      </label>
    </div>
  }
  <!-- DROPDOWN VALUES -->
  <div class="axis-grid">
    @for (control of controls | slice: 4; track $index) {
      @if (baseRules[control.baseRuleKey]) {
        <div class="axis-col-sm-6 axis-col-lg-6">
          <div class="axis-form-group">
            <label class="axis-control-label">{{ control.label }}</label>
            <div>{{ control.data[0].name }}</div>
          </div>
        </div>
      }
    }
  </div>
  <!--UMPD Reject text-->
  @if (baseRules?.Reject_LevelTwo_UMPD_Radio) {
    <div class="axis-form-group">
      <label class="axis-control-label">
        {{ textValues?.Reject_Text_UMPD }}
      </label>
    </div>
  }
}
